import {useEffect, useState} from "react";
import firebase from "firebase";
import {IAdmin, Roles} from "@evennt-tech/api-v2-core";
import {apiV2} from "api/firebase";

type UseAdminResult = [IAdmin | null, boolean];

interface AdminData {
  user: IAdmin | null;
  loading: boolean;
}

export default (): UseAdminResult => {
  const [userData, setUserData] = useState<AdminData>({
    user: null,
    loading: true,
  });

  useEffect(() => {
    let isMounted = true;

    const unsubscribe = firebase.auth().onAuthStateChanged(async (user) => {
      if (!isMounted) return;

      const me = await apiV2.user.getMe();

      if (!user || !me) {
        setUserData({user: null, loading: false});
        return;
      }

      try {
        if (me?.role !== Roles.ADMIN) {
          setUserData({user: null, loading: false});

          return;
        }

        const adminMe = await apiV2.admin.getMe();

        setUserData({user: adminMe, loading: false});
      } catch (error) {
        console.error("Error fetching admin info:", error);
        setUserData({user: null, loading: false});
      }
    });

    return () => {
      isMounted = false;
      unsubscribe();
    };
  }, []);

  return [userData.user, userData.loading];
};
